import { EN_KO } from './_EN_KO.js';

EN_KO.deferredExecute = EN_KO.deferredExecute || [];

const ready = function( name, fn ) {
	const jQuery = window.jQuery;

	if ( 'undefined' !== typeof jQuery ) {
		jQuery( document ).ready( fn );
	} else {
		EN_KO.deferredExecute.push( function() {
			fn( jQuery );
		} );
	}
};

const promiseChain = [];
const chainReady = function( name, fn, priority ) {
	promiseChain.push( {
		name,
		func() {
			return new Promise( function( resolve, reject ) {
				return fn( resolve, reject );
			} );
		},
		priority,
	} );

	promiseChain.sort( function( a, b ) {
		return a.priority - b.priority;
	} );
};

ready( 'Promises', function() {
	const promises = promiseChain;

	// Run all chained inits, ordered by priority.
	return promises.reduce( function( accumulator, callback ) {
		return accumulator.then( callback.func );
	}, Promise.resolve( true ) );
} );

const TaoReady = {
	ready,
	promiseChain,
	chainReady,
};

export default TaoReady;
